export const getNumericRotate = (rotate?: number | string) => {
  return typeof rotate === "string" ? parseInt(rotate) : (rotate ?? 0);
};
